// store/thunks/auth/forgotPasswordThunk.ts
import { createAppAsyncThunk } from '@/store/thunks/createAppAsyncThunk';

export const forgotPasswordThunk = createAppAsyncThunk<
  undefined,
  { emailAddress: string },
  { rejectValue: { message: string } }
>(
  'auth/forgotPasswordThunk',
  async({ emailAddress }, { extra: { authService }, rejectWithValue }) => {
    try {
      await authService.forgotPassword({ emailAddress });
    } catch (caught) {
      const message =
        caught instanceof Error ? caught.message : 'Failed to send reset password email';
      return rejectWithValue({ message });
    }
  }
);
